export default function Switch({
  loading,
  onChange,
  checked,
  label,
  hint,
  id,
}) {
  return (
    <div className="form-check form-switch">
      {/* Bug real (auditoría 2026-08-16): loading se recibía pero nunca se
          usaba — sin disabled, un caller que cablee el isLoading de una
          mutación acá no tendría ninguna protección real contra el
          usuario tocando el switch de nuevo mientras el toggle anterior
          todavía está en vuelo (doble-toggle). */}
      <input
        className="form-check-input"
        type="checkbox"
        id={`switch${id}`}
        checked={checked}
        onChange={onChange}
        disabled={loading}
      />
      <label className="form-check-label" htmlFor={`switch${id}`}>
        {label}
      </label>
      {hint && (
        <div className="form-text" dangerouslySetInnerHTML={{ __html: hint }} />
      )}
    </div>
  );
}
